"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var serialize_param_1 = require("./serialize-param");
var add_param_1 = require("./add-param");
var is_object_1 = require("./is-object");
var is_string_1 = require("./is-string");
var is_function_1 = require("./is-function");
var safe_get_1 = require("./safe-get");
/**
 * 发起 ajax 请求，支持 GET 和 POST
 *
 * @template T 返回值类型
 * @param {IHttpRequestOptions} 请求选项
 * @returns {Promise<T>}
 */
function ajax(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.method, method = _c === void 0 ? 'GET' : _c, url = _b.url, _d = _b.param, param = _d === void 0 ? {} : _d, timeout = _b.timeout;
    if (!url || !is_object_1.default(param) || !is_string_1.default(method)) {
        return Promise.reject(new Error('Param error.'));
    }
    var xhr = new XMLHttpRequest();
    // if (timeout) {
    //     xhr.timeout = timeout * 1000;
    // }
    if (method === 'GET') {
        // get 请求 参数处理
        url = add_param_1.default(param, url);
        xhr.open(method, url, true);
    }
    else {
        // post header 处理
        xhr.open(method, url, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    var timer;
    return new Promise(function (resolve, reject) {
        var isTimeout = false;
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                clearTimeout(timer);
                if (isTimeout)
                    return;
                if (xhr.status >= 200 && xhr.status < 300) {
                    try {
                        if (is_function_1.default(safe_get_1.default(JSON, 'parse'))) {
                            return resolve(JSON.parse(xhr.responseText));
                        }
                        // rollup 优化... https://rollupjs.org/guide/en#avoiding-eval
                        var eval2 = eval;
                        return resolve(eval2('(' + xhr.responseText + ')'));
                    }
                    catch (e) {
                        return reject({
                            ret: -9999,
                            path: url,
                            msg: '系统繁忙，请稍后再试！(-9999)'
                        });
                    }
                }
                else if (xhr.status >= 300) {
                    reject({
                        ret: -9998,
                        path: url,
                        msg: "\u7CFB\u7EDF\u7E41\u5FD9\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\uFF01(-9998-" + xhr.status + ")"
                    });
                }
                else {
                    reject({
                        ret: -9996,
                        path: url,
                        msg: '系统繁忙，请稍后再试！(-9996)'
                    });
                }
            }
        };
        if (timeout) {
            timer = setTimeout(function () {
                isTimeout = true;
                try {
                    xhr.abort();
                }
                catch (e) { }
                return reject({
                    ret: -9997,
                    path: url,
                    msg: '对不起，请求超时！'
                });
            }, timeout * 1000);
        }
        // xhr.ontimeout = function() {
        //     return reject({
        //         ret: -9997,
        //         path: url,
        //         msg: '对不起，请求超时！'
        //     });
        // };
        var body = method === 'POST' ? serialize_param_1.default(param) : undefined;
        xhr.send(body);
    });
}
exports.default = ajax;
//# sourceMappingURL=ajax.js.map